import React from 'react';
import { FooterSectionContent } from './FooterSectionContent';
import { SectionContainer, LeftAsset, StyledCloudImage } from './FooterSection.styles';

export const FooterSectionMobile = () => {
  return (
    <SectionContainer id="our_story_footer_section_mobile" src="our-story/footer-cta/img.jpg" optimization="mild" isResizeDisabled>
      <FooterSectionContent mobile />
      <LeftAsset>
        <StyledCloudImage src="our-story/footer-cta/curl2.svg" width="55vw" height="100%" />
      </LeftAsset>
    </SectionContainer>
  );
};
